import {
  ACCOMMODATION_SERVICES_SECTOR,
  ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR,
  ARTS_ENTERTAINMENT_SECTOR,
  CONSTRUCTION_SECTOR,
  EDUCATIONAL_SERVICES_SECTOR,
  FINANCE_AND_INSURANCE_SECTOR,
  FISHING_AND_HUNTING_SECTOR,
  HEALTH_CARE_SECTOR,
  INFORMATION_SECTOR,
  MANAGEMENT_OF_COMPANIES_SECTOR,
  MANUFACTURING_SECTOR,
  MINING_QUARRYING_OIL_AND_GAS_SECTOR,
  OTHER_SERVICES_SECTOR,
  PUBLIC_ADMINISTRATION_SECTOR,
  REAL_ESTATE_SECTOR,
  RETAIL_TRADE_SECTOR,
  SCIENTIFIC_SERVICES_SECTOR,
  TRANSPORTATION_AND_WAREHOUSING_SECTOR,
  UTILITIES_SECTOR,
  WHOLESALE_TRADE_SECTOR,
} from '../industrySectorOptions';
import {
  ACCOMMODATION_SUB_SECTOR,
  ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
  ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
  ADMINISTRATIVE_SERVICE_SUB_SECTOR,
  AGENTS_AND_BROKERS_SUB_SECTOR,
  AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR,
  AIR_TRANSPORTATION_SUB_SECTOR,
  AMBULATORY_CARE_SUB_SECTOR,
  AMUSEMENT_INDUSTRY_SUB_SECTOR,
  ANIMAL_AND_AGRICULTURE_SUB_SECTOR,
  APPAREL_MANUFACTURING_SUB_SECTOR,
  BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR,
  BROADCASTING_PROVIDER_SUB_SECTOR,
  BUILDING_CONSTRUCTION_SUB_SECTOR,
  BUILDING_MATERIAL_DEALERS_SUB_SECTOR,
  CHEMICAL_MANUFACTURING_SUB_SECTOR,
  CLOTHING_RETAILERS_SUB_SECTOR,
  COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR,
  COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
  COURIERS_SUB_SECTOR,
  CREDIT_INTERMEDIATION_SUB_SECTOR,
  CROP_PRODUCTION_SUB_SECTOR,
  DURABLE_GOODS_SUB_SECTOR,
  EDUCATIONAL_SERVICES_SUB_SECTOR,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
  FABRICATED_METAL_MANUFACTURING_SUB_SECTOR,
  FISHING_HUNTING_TRAPPING_SUB_SECTOR,
  FOOD_MANUFACTURING_SUB_SECTOR,
  FOOD_RETAILERS_SUB_SECTOR,
  FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR,
  FORESTRY_AND_LOGGING_SUB_SECTOR,
  FUNDS_TRUSTS_SUB_SECTOR,
  FURNITURE_MANUFACTURING_SUB_SECTOR,
  FURNITURE_RETAILERS_SUB_SECTOR,
  GASOLINE_DEALERS_SUB_SECTOR,
  HEALTH_RETAILERS_SUB_SECTOR,
  HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR,
  HOSPITALS_SUB_SECTOR,
  INSURANCE_CARRIERS_SUB_SECTOR,
  JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
  LAUNDRY_SERVICE_SUB_SECTOR,
  LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR,
  LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
  MACHINERY_MANUFACTURING_SUB_SECTOR,
  MERCHANDISE_RETAILERS_SUB_SECTOR,
  MINING_SUB_SECTOR,
  MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
  MISCELLANEOUS_MANUFACTURING_SUB_SECTOR,
  MONETARY_BANK_SUB_SECTOR,
  MOTION_PIC_INDUSTRIES_SUB_SECTOR,
  MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR,
  MUSEUMS_SUB_SECTOR,
  NATIONAL_SECURITY_SUB_SECTOR,
  NONDURABLE_GOODS_SUB_SECTOR,
  NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR,
  NURSING_FACILITIES_SUB_SECTOR,
  OIL_GAS_EXTRACTION_SUB_SECTOR,
  PAPER_MANUFACTURING_SUB_SECTOR,
  PERFORMING_ARTS_SUB_SECTOR,
  PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
  PIPELINE_TRANSPORTATION_SUB_SECTOR,
  PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR,
  POSTAL_SERVICE_SUB_SECTOR,
  PRIMARY_METAL_MANUFACTURING_SUB_SECTOR,
  PRINTING_MANUFACTURING_SUB_SECTOR,
  PRIVATE_HOUSEHOLDS_SUB_SECTOR,
  PUBLISHING_INDUSTRIES_SUB_SECTOR,
  RAIL_TRANSPORTATION_SUB_SECTOR,
  REAL_ESTATE_SUB_SECTOR,
  RELIGIOUS_SUB_SECTOR,
  RENTAL_AND_LEASING_SUB_SECTOR,
  REPAIR_AND_MAINTENANCE_SUB_SECTOR,
  SCENIC_TRANSPORTATION_SUB_SECTOR,
  SECURITIES_COMMODITY_SUB_SECTOR,
  SOCIAL_ASSISTANCE_SUB_SECTOR,
  SPACE_RESEARCH_SUB_SECTOR,
  SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR,
  SPORTING_GOODS_RETAILERS_SUB_SECTOR,
  SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR,
  TELECOMMUNICATION_SUB_SECTOR,
  TEXTILE_MILLS_SUB_SECTOR,
  TEXTILE_PRODUCT_MILLS_SUB_SECTOR,
  TRANSIT_TRANSPORTATION_SUB_SECTOR,
  TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  TRUCK_TRANSPORTATION_SUB_SECTOR,
  WAREHOUSING_AND_STORAGE_SUB_SECTOR,
  WASTE_MANAGEMENT_SUB_SECTOR,
  WATER_TRANSPORTATION_SUB_SECTOR,
  WEB_SEARCH_PORTALS_SUB_SECTOR,
  WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR,
} from '../industrySubSectorOptions';

export const SUB_SECTOR_OPTIONS_ES = {
  [FISHING_AND_HUNTING_SECTOR]: [
    { value: CROP_PRODUCTION_SUB_SECTOR, label: 'Producción Agrícola' },
    { value: ANIMAL_AND_AGRICULTURE_SUB_SECTOR, label: 'Producción Animal y Acuicultura' },
    { value: FORESTRY_AND_LOGGING_SUB_SECTOR, label: 'Silvicultura y Explotación Forestal' },
    { value: FISHING_HUNTING_TRAPPING_SUB_SECTOR, label: 'Pesca, Caza y Captura' },
    { value: AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR, label: 'Servicios de Apoyo para la Agricultura y la Silvicultura' },
  ],

  [MINING_QUARRYING_OIL_AND_GAS_SECTOR]: [
    { value: OIL_GAS_EXTRACTION_SUB_SECTOR, label: 'Extracción de Petróleo y Gas' },
    { value: MINING_SUB_SECTOR, label: 'Minería (excepto Petróleo y Gas)' },
    { value: MINING_SUPPORT_ACTIVITIES_SUB_SECTOR, label: 'Servicios de Apoyo para la Minería' },
  ],

  [UTILITIES_SECTOR]: [],

  [CONSTRUCTION_SECTOR]: [
    { value: BUILDING_CONSTRUCTION_SUB_SECTOR, label: 'Construcción de Edificios' },
    { value: HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR, label: 'Obras de Ingeniería Civil e Infraestructura' },
    { value: SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR, label: 'Contratistas Especializados' },
  ],

  [MANUFACTURING_SECTOR]: [
    { value: FOOD_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Alimentos' },
    { value: BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Bebidas y Productos de Tabaco' },
    { value: TEXTILE_MILLS_SUB_SECTOR, label: 'Fabricación de Textiles' },
    { value: TEXTILE_PRODUCT_MILLS_SUB_SECTOR, label: 'Fabricación de Productos Textiles' },
    { value: APPAREL_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Prendas de Vestir' },
    { value: LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Cuero y Productos Relacionados' },
    { value: WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Productos de Madera' },
    { value: PAPER_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Papel' },
    { value: PRINTING_MANUFACTURING_SUB_SECTOR, label: 'Impresión y Servicios Relacionados' },
    { value: PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Productos Derivados del Petróleo y el Carbón' },
    { value: CHEMICAL_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Productos Químicos' },
    { value: PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Productos de Plástico y Caucho' },
    { value: NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Productos Minerales No Metálicos' },
    { value: PRIMARY_METAL_MANUFACTURING_SUB_SECTOR, label: 'Metalurgia Primaria' },
    { value: FABRICATED_METAL_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Productos Metálicos' },
    { value: MACHINERY_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Maquinaria' },
    { value: COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Equipos Informáticos y Productos Electrónicos' },
    {
      value: ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
      label: 'Fabricación de Equipos Eléctricos, Electrodomésticos y Componentes',
    },
    { value: TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Equipos de Transporte' },
    { value: FURNITURE_MANUFACTURING_SUB_SECTOR, label: 'Fabricación de Muebles y Productos Relacionados' },
    { value: MISCELLANEOUS_MANUFACTURING_SUB_SECTOR, label: 'Otras Industrias Manufactureras' },
  ],

  [WHOLESALE_TRADE_SECTOR]: [
    { value: DURABLE_GOODS_SUB_SECTOR, label: 'Comercio Mayorista de Bienes Duraderos' },
    { value: NONDURABLE_GOODS_SUB_SECTOR, label: 'Comercio Mayorista de Bienes No Duraderos' },
    { value: AGENTS_AND_BROKERS_SUB_SECTOR, label: 'Agentes e Intermediarios del Comercio Mayorista' },
  ],

  [RETAIL_TRADE_SECTOR]: [
    { value: MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR, label: 'Venta de Vehículos Motorizados y Repuestos' },
    {
      value: BUILDING_MATERIAL_DEALERS_SUB_SECTOR,
      label: 'Venta de Materiales de Construcción, Equipos y Suministros para Jardinería',
    },
    { value: FOOD_RETAILERS_SUB_SECTOR, label: 'Comercio Minorista de Alimentos y Bebidas' },
    {
      value: FURNITURE_RETAILERS_SUB_SECTOR,
      label: 'Venta de Muebles, Artículos para el Hogar, Electrónica y Electrodomésticos',
    },
    { value: MERCHANDISE_RETAILERS_SUB_SECTOR, label: 'Comercio Minorista de Mercancías Generales' },
    { value: HEALTH_RETAILERS_SUB_SECTOR, label: 'Comercio Minorista de Productos de Salud y Cuidado Personal' },
    { value: GASOLINE_DEALERS_SUB_SECTOR, label: 'Estaciones de Servicio y Distribuidores de Combustible' },
    { value: CLOTHING_RETAILERS_SUB_SECTOR, label: 'Venta de Ropa, Accesorios, Calzado y Joyería' },
    {
      value: SPORTING_GOODS_RETAILERS_SUB_SECTOR,
      label: 'Venta de Artículos Deportivos, Pasatiempos, Instrumentos Musicales, Libros y Otros Productos',
    },
  ],

  [TRANSPORTATION_AND_WAREHOUSING_SECTOR]: [
    { value: AIR_TRANSPORTATION_SUB_SECTOR, label: 'Transporte Aéreo' },
    { value: RAIL_TRANSPORTATION_SUB_SECTOR, label: 'Transporte Ferroviario' },
    { value: WATER_TRANSPORTATION_SUB_SECTOR, label: 'Transporte Marítimo y Fluvial' },
    { value: TRUCK_TRANSPORTATION_SUB_SECTOR, label: 'Transporte por Carretera' },
    { value: TRANSIT_TRANSPORTATION_SUB_SECTOR, label: 'Transporte Público y Transporte Terrestre de Pasajeros' },
    { value: PIPELINE_TRANSPORTATION_SUB_SECTOR, label: 'Transporte por Oleoductos y Gasoductos' },
    { value: SCENIC_TRANSPORTATION_SUB_SECTOR, label: 'Transporte Turístico y Panorámico' },
    { value: SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR, label: 'Servicios de Apoyo al Transporte' },
    { value: POSTAL_SERVICE_SUB_SECTOR, label: 'Servicios Postales' },
    { value: COURIERS_SUB_SECTOR, label: 'Mensajería y Paquetería' },
    { value: WAREHOUSING_AND_STORAGE_SUB_SECTOR, label: 'Almacenamiento y Depósito' },
  ],

  [INFORMATION_SECTOR]: [
    { value: MOTION_PIC_INDUSTRIES_SUB_SECTOR, label: 'Industria Cinematográfica y de Grabación de Sonido' },
    { value: PUBLISHING_INDUSTRIES_SUB_SECTOR, label: 'Industria Editorial' },
    { value: BROADCASTING_PROVIDER_SUB_SECTOR, label: 'Radiodifusión y Proveedores de Contenido' },
    { value: TELECOMMUNICATION_SUB_SECTOR, label: 'Telecomunicaciones' },
    {
      value: COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
      label: 'Infraestructura Informática, Procesamiento de Datos, Alojamiento Web y Servicios Relacionados',
    },
    {
      value: WEB_SEARCH_PORTALS_SUB_SECTOR,
      label: 'Portales de Búsqueda, Bibliotecas, Archivos y Otros Servicios de Información',
    },
  ],

  [FINANCE_AND_INSURANCE_SECTOR]: [
    { value: MONETARY_BANK_SUB_SECTOR, label: 'Banco Central y Autoridades Monetarias' },
    { value: CREDIT_INTERMEDIATION_SUB_SECTOR, label: 'Intermediación Crediticia y Actividades Relacionadas' },
    {
      value: SECURITIES_COMMODITY_SUB_SECTOR,
      label: 'Valores, Contratos de Materias Primas, Inversiones Financieras y Actividades Relacionadas',
    },
    { value: INSURANCE_CARRIERS_SUB_SECTOR, label: 'Compañías de Seguros y Actividades Relacionadas' },
    { value: FUNDS_TRUSTS_SUB_SECTOR, label: 'Fondos, Fideicomisos y Otros Vehículos Financieros' },
  ],

  [REAL_ESTATE_SECTOR]: [
    { value: REAL_ESTATE_SUB_SECTOR, label: 'Bienes Raíces' },
    { value: RENTAL_AND_LEASING_SUB_SECTOR, label: 'Servicios de Alquiler y Arrendamiento' },
    {
      value: LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
      label: 'Arrendamiento de Activos Intangibles No Financieros (excepto Obras Protegidas por Derechos de Autor)',
    },
  ],

  [SCIENTIFIC_SERVICES_SECTOR]: [],
  [MANAGEMENT_OF_COMPANIES_SECTOR]: [],

  [ADMINISTRATIVE_AND_SUPPORT_SERVICES_SECTOR]: [
    { value: ADMINISTRATIVE_SERVICE_SUB_SECTOR, label: 'Servicios Administrativos y de Apoyo' },
    { value: WASTE_MANAGEMENT_SUB_SECTOR, label: 'Gestión de Residuos y Remediación Ambiental' },
  ],

  [EDUCATIONAL_SERVICES_SECTOR]: [
    { value: EDUCATIONAL_SERVICES_SUB_SECTOR, label: 'Servicios Educativos' },
  ],

  [HEALTH_CARE_SECTOR]: [
    { value: AMBULATORY_CARE_SUB_SECTOR, label: 'Servicios de Atención Médica Ambulatoria' },
    { value: HOSPITALS_SUB_SECTOR, label: 'Hospitales' },
    { value: NURSING_FACILITIES_SUB_SECTOR, label: 'Centros de Enfermería y Atención Residencial' },
    { value: SOCIAL_ASSISTANCE_SUB_SECTOR, label: 'Asistencia Social' },
  ],

  [ARTS_ENTERTAINMENT_SECTOR]: [
    { value: PERFORMING_ARTS_SUB_SECTOR, label: 'Artes Escénicas, Deportes para Espectadores e Industrias Relacionadas' },
    { value: MUSEUMS_SUB_SECTOR, label: 'Museos, Sitios Históricos e Instituciones Similares' },
    { value: AMUSEMENT_INDUSTRY_SUB_SECTOR, label: 'Entretenimiento, Juegos de Azar y Recreación' },
  ],

  [ACCOMMODATION_SERVICES_SECTOR]: [
    { value: ACCOMMODATION_SUB_SECTOR, label: 'Alojamiento' },
    { value: FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR, label: 'Servicios de Alimentación y Bebidas' },
  ],

  [OTHER_SERVICES_SECTOR]: [
    { value: REPAIR_AND_MAINTENANCE_SUB_SECTOR, label: 'Reparación y Mantenimiento' },
    { value: LAUNDRY_SERVICE_SUB_SECTOR, label: 'Servicios Personales y de Lavandería' },
    { value: RELIGIOUS_SUB_SECTOR, label: 'Organizaciones Religiosas, Benéficas, Cívicas, Profesionales y Similares' },
    { value: PRIVATE_HOUSEHOLDS_SUB_SECTOR, label: 'Hogares Privados' },
  ],

  [PUBLIC_ADMINISTRATION_SECTOR]: [
    { value: EXECUTIVE_LEGISLATIVE_SUB_SECTOR, label: 'Poder Ejecutivo, Legislativo y Servicios Generales del Gobierno' },
    { value: JUSTICE_PUBLIC_ORDER_SUB_SECTOR, label: 'Justicia, Orden Público y Seguridad' },
    { value: ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR, label: 'Administración de Programas de Recursos Humanos' },
    {
      value: ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
      label: 'Administración de Programas de Calidad Ambiental',
    },
    {
      value: ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
      label: 'Administración de Programas de Vivienda, Urbanismo y Desarrollo Comunitario',
    },
    { value: ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR, label: 'Administración de Programas Económicos' },
    { value: SPACE_RESEARCH_SUB_SECTOR, label: 'Investigación y Tecnología Espacial' },
    { value: NATIONAL_SECURITY_SUB_SECTOR, label: 'Seguridad Nacional y Asuntos Internacionales' },
  ],
};

